import React, { useState, useEffect } from "react";
import { FaRegCheckCircle, FaRegCircle } from "react-icons/fa";
import { HelpPopup } from "../HelpPopup";
import { HelpButtonExpanded } from "../common/HelpButtonExpanded";
import { contact } from "../../configs/sysInfoConfig";
import { getSysInfo } from "../../services/dashApiService";

export const Consent = ({ onConsentCheck, checked }) => {
	const [isShowingConsentHelp, setIsShowingConsentHelp] = useState(false);
	const [helpCode, setHelpCode] = useState();

	const handleShowHelp = (helpCode) => {
		setHelpCode(helpCode);
		setIsShowingConsentHelp(true);
	};

	const [sysInfo, setSysInfo] = useState(contact);
	useEffect(() => {
		let didCancel = false;
		getSysInfo()
			.then((result) => {
				if (result.success) {
					const data = result.data;
					if (!didCancel) {
						setSysInfo(data.contact);
					}
				} else {
					console.error(result.err);
				}
			})
			.catch((error) => {
				console.error("Error getting contact info: ", error);
			});

		return () => {
			didCancel = true;
		};
	}, []);

	return (
		<>
			<div className={"flex-grow overflow-y-auto pt-2 sm:pt-4"}>
				<div className={"text-md sm:text-md"}>
					<div className={"mb-4"}>
						<p className={"mb-6 text-xl"}>
							Please take a few moments to read the consent information and
							terms and conditions of use, and tick to show you are happy to
							proceed:
						</p>
						<div
							className={
								"w-full mx-auto space-y-2 pb-6 border-b-2 border-white border-opacity-50"
							}
						>
							<HelpButtonExpanded
								onClick={() => handleShowHelp("Home.setup.consentINFO")}
								text={"Your Health Companion Consent Info"}
								linkColorOverride="text-app-midblue"
								textSizeOverride="text-md"
							/>
							<HelpButtonExpanded
								onClick={() => handleShowHelp("Home.setup.consentTCs")}
								text={"Terms and Conditions of use"}
								linkColorOverride="text-app-midblue"
								textSizeOverride="text-md"
							/>
						</div>
					</div>

					<div
						className={
							"w-full text-left pb-4 border-b-2 border-slate-400 border-opacity-50"
						}
					>
						<div
							className={"max-w-sm mx-auto flex justify-between items-center"}
						>
							<p className={"font-bold w-4/5"}>
								Please confirm you have read the consent information by ticking
								here:
							</p>

							{checked ? (
								<FaRegCheckCircle
									onClick={onConsentCheck}
									className={"text-3xl text-gray-600"}
								/>
							) : (
								<FaRegCircle
									onClick={onConsentCheck}
									className={"text-3xl text-gray-400"}
								/>
							)}
						</div>
					</div>
					<div className={"pt-6"}>
						<p className={"mb-4 sm:mb-6 "}>
							If you're at all stuck at any time, or wish to discuss consent
							further before proceeding, please call or email Your Health
							Companion support on:
						</p>

						<p>
							<span className={"w-14 inline-block font-bold"}>Email:</span>
							<a href={`mailto:${sysInfo.email}`} className={"font-normal"}>
								{sysInfo.email}
							</a>
						</p>

						<p>
							<span className={"w-14 inline-block font-bold"}>Tel:</span>
							<a
								href={`tel:${sysInfo.telephone.replace(/\s+/g, "")}`}
								className={"font-normal"}
							>
								{sysInfo.telephone}
							</a>
						</p>
					</div>
				</div>
			</div>

			<HelpPopup
				show={isShowingConsentHelp}
				onClose={() => setIsShowingConsentHelp(false)}
				helpCode={helpCode}
			/>
		</>
	);
};
